import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { ArrowRight, Calendar, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { Card } from '../components/ui/Card';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
export function ServicesPage() {
  const {
    t,
    lang
  } = useTranslation();
  const seoTitle = lang === 'en' ? 'Dental Services in Angel, London | Dentico Clinic' : lang === 'ua' ? 'Стоматологічні послуги в Angel, Лондон | Dentico Clinic' : lang === 'ro' ? 'Servicii Dentare în Angel, Londra | Dentico Clinic' : 'Стоматологические услуги в Angel, Лондон | Dentico Clinic';
  const seoDescription = lang === 'en' ? 'Explore private dental services at Dentico Clinic in Angel, including hygiene, fillings, veneers, implants, orthodontics and emergency care.' : lang === 'ua' ? 'Ознайомтеся з приватними стоматологічними послугами в Dentico Clinic в Angel, включаючи гігієну, пломби, вініри, імпланти, ортодонтію та невідкладну допомогу.' : lang === 'ro' ? 'Explorați serviciile dentare private la Dentico Clinic din Angel, inclusiv igienă, plombe, fațete, implanturi, ortodonție și îngrijire de urgență.' : 'Ознакомьтесь с частными стоматологическими услугами в Dentico Clinic в Angel, включая гигиену, пломбы, виниры, импланты, ортодонтию и неотложную помощь.';
  const services = [{
    id: 'fillings',
    title: t('services.fillings.title'),
    description: t('services.fillings.desc'),
    image: 'https://drive.google.com/thumbnail?id=1GoYPTv2Ah2lfohOV_wcv06DwMvJ8-YIf&sz=w1200'
  }, {
    id: 'root-canal',
    title: t('services.rootCanal.title'),
    description: t('services.rootCanal.desc'),
    image: 'https://drive.google.com/thumbnail?id=1oecjcYpi0WMZbrhKFXRxj1Z597Vlnj1m&sz=w1200'
  }, {
    id: 'crowns',
    title: t('services.crowns.title'),
    description: t('services.crowns.desc'),
    image: 'https://images.unsplash.com/photo-1606265752439-1f18756aa5fc?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'hygiene',
    title: t('services.hygiene.title'),
    description: t('services.hygiene.desc'),
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'whitening',
    title: t('services.whitening.title'),
    description: t('services.whitening.desc'),
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'extraction',
    title: t('services.extraction.title'),
    description: t('services.extraction.desc'),
    image: 'https://drive.google.com/thumbnail?id=1H9Sf4ZxWwyVlbdh7GXl7iGQTbjS1U2mD&sz=w1200'
  }, {
    id: 'smile-makeover',
    title: t('services.smileMakeover.title'),
    description: t('services.smileMakeover.desc'),
    image: 'https://cdn.magicpatterns.com/uploads/aws3cmiUVaQNLxKjpQRh73/IMG_3720.jpg'
  }, {
    id: 'cosmetic',
    title: t('services.cosmetic.title'),
    description: t('services.cosmetic.desc'),
    image: 'https://drive.google.com/thumbnail?id=1WfQHZfd0cw_7cJJrW6R75IqRiZXZJ9Yb&sz=w1200'
  }, {
    id: 'paediatric-dentistry',
    title: t('services.paediatric.title'),
    description: t('services.paediatric.desc'),
    image: 'https://drive.google.com/thumbnail?id=1EkX5ZapNGT_ssdlSh1hBhv8Yym2-cS-j&sz=w1200'
  }];
  return <Layout title={seoTitle} description={seoDescription} data-id="element-4469" data-mp="1b2xis69dpsy5">
      <div className="bg-forest-900 py-16 lg:py-20 text-white" data-id="element-4470" data-mp="1b1co8gn2ea0a">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-4471" data-mp="3huoihbnxteaa">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-4472" data-mp="3cvln6ixremfi">
            {t('servicesPage.title')}
          </h1>
          <p className="text-xl text-ivory/80 max-w-2xl mx-auto" data-id="element-4473" data-mp="3eb65c1nq8nx5">
            {t('servicesPage.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-id="element-4474" data-mp="3jcvjvra5rjpz">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4475" data-mp="3oawy9ywn2uv4">
          {services.map(service => <Card key={service.id} hover className="overflow-hidden flex flex-col h-full border-0 shadow-lg" data-id="element-4476" data-mp="3t75kfw997obs">
              <Link to={`/${lang}/services/${service.id}`} className="block" data-id="element-4477" data-mp="30lcifovs8dq2">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-4478" data-mp="35jdxlyq37sw9">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-4479" data-mp="3aadyff2buv41" />
                </div>
              </Link>

              <div className="p-6 flex flex-col flex-grow" data-id="element-4480" data-mp="2hrysxzau8zhu">
                <Link to={`/${lang}/services/${service.id}`} data-id="element-4481" data-mp="yxxdf9iuoql6">
                  <h2 className="text-xl font-bold text-charcoal mb-3 hover:text-forest-600 transition-colors" data-id="element-4482" data-mp="uxdd5x2zd6ut">
                    {service.title}
                  </h2>
                </Link>
                <p className="text-charcoal-light mb-6 text-sm line-clamp-2 flex-grow" data-id="element-4483" data-mp="kz62fvzabl19">
                  {service.description}
                </p>

                <div className="flex gap-3 mt-auto" data-id="element-4484" data-mp="g0w6hj5qkgel">
                  <Link to={`/${lang}/services/${service.id}`} className="flex-1" data-id="element-4485" data-mp="b9e0uhsrprna">
                    <Button variant="outline" size="sm" fullWidth data-id="element-4486" data-mp="78kf9v2ssoxk">
                      {t('services.learnMore')}
                    </Button>
                  </Link>
                  <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="flex-1" data-id="element-4487" data-mp="3tfioes22xsfg">
                    <Button size="sm" fullWidth data-id="element-4488" data-mp="3erqzynu2fmvs">
                      {t('nav.bookOnline')}
                    </Button>
                  </a>
                </div>
              </div>
            </Card>)}
        </div>
      </div>

      <div className="bg-ivory-200 py-16 lg:py-20" data-id="element-4489" data-mp="35t6nw5j0gbgj">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-4490" data-mp="39sxkipv7xlsz">
          <h2 className="text-3xl font-bold text-charcoal mb-6" data-id="element-4491" data-mp="39va1p0t5js4z">
            {t('servicesPage.readyToBook')}
          </h2>
          <p className="text-charcoal-light mb-8" data-id="element-4492" data-mp="6ch1rqtar1ta">
            {t('servicesPage.readyToBookDesc')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-4493" data-mp="3oqq35qw2aqbe">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-4494" data-mp="3oonaez3iyj2z">
              <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-4495" data-mp="3sq8mwjc5cvcn">
                <Calendar className="w-5 h-5" data-id="element-4496" data-mp="kb6zn8nxx5ip" />
                {t('servicesPage.bookOnlineNow')}
              </Button>
            </a>
            <a href="https://wa.me/447345197820" target="_blank" rel="noopener noreferrer" data-id="element-4497" data-mp="p52uw3ctkea6">
              <Button variant="whatsapp" size="lg" className="gap-2 w-full sm:w-auto" data-id="element-4498" data-mp="24v2e4t3kqijb">
                WhatsApp
              </Button>
            </a>
            <Link to={`/${lang}/contact`} data-id="element-4499" data-mp="2el55ypyylqg2">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-4500" data-mp="2em6pzjxydn9x">
                {lang === 'en' ? 'Request a Call' : lang === 'ua' ? 'Замовити дзвінок' : lang === 'ru' ? 'Заказать звонок' : 'Solicitați un Apel'}
              </Button>
            </Link>
            <Link to={`/${lang}/prices`} data-id="element-4501" data-mp="3c6t1z9ri66r2">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-4502" data-mp="3c9yqamsb54lq">
                {lang === 'en' ? 'View Prices' : lang === 'ua' ? 'Переглянути ціни' : lang === 'ru' ? 'Посмотреть цены' : 'Vedeți Prețurile'}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>;
}